// extracted by mini-css-extract-plugin
var _1 = "TableCellButton-moduleTableCellButton__SRXTh";
export { _1 as "TableCellButton" }
